/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ticketpagerefundedorders3Inputs */

const en_ticketpagerefundedorders3 = /** @type {(inputs: Ticketpagerefundedorders3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} orders`)
};

const de_ticketpagerefundedorders3 = /** @type {(inputs: Ticketpagerefundedorders3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bestellungen`)
};

/**
* | output |
* | --- |
* | "{count} orders" |
*
* @param {Ticketpagerefundedorders3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagerefundedorders3 = /** @type {((inputs: Ticketpagerefundedorders3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagerefundedorders3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagerefundedorders3(inputs)
	return de_ticketpagerefundedorders3(inputs)
});
export { ticketpagerefundedorders3 as "ticketPageRefundedOrders" }